import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';

import { CodesetState } from './codeset.reducer';
import { loadCodeSet } from './codeset.actions';
import { codeSetQuery } from './codeset.selectors';

@Injectable({
  providedIn: 'root',
})
export class CodesetFacade {
  codeSetResponse$ = this.store$.pipe(select(codeSetQuery.getCodeset));

  constructor(private store$: Store<CodesetState>) {}

  loadCodeSet() {
    this.store$.dispatch(loadCodeSet());
  }
}
